module.exports = __webpack_public_path__ + "img/token__active.2e401562.svg";